import { FC, useState } from 'react';

import { Language, Public } from '@mui/icons-material';
import { BottomNavigation, BottomNavigationAction, Card, Grid } from '@mui/material';

import LoadingDashboardWrapper from '../../LoadingDashboardWrapper';
import EuropeMap from './EuropeMap';
import GermanyMap from './GermanyMap';

interface Props {
    germanyCount?: any;
    loading?: boolean;
}

const OverviewAdmin: FC<Props> = ({ germanyCount, loading }) => {
    const [value, setValue] = useState<'de' | 'eu'>('de');

    return (
        <Grid container spacing={2}>
            <Grid item lg={8} xs={12}>
                <Card sx={{ width: '100%', minHeight: 500 }}></Card>
            </Grid>
            <Grid item lg={4} xs={12}>
                <Card sx={{ width: '100%', minHeight: 500 }}>
                    <LoadingDashboardWrapper loading={loading}>
                        {value === 'de' && <GermanyMap germanyCount={germanyCount} />}
                        {value === 'eu' && <EuropeMap />}

                        <BottomNavigation
                            showLabels
                            value={value}
                            onChange={(event, newValue) => {
                                setValue(newValue);
                            }}>
                            <BottomNavigationAction value='de' label='Deutschland' icon={<Public />} />
                            <BottomNavigationAction value='eu' label='Europa' icon={<Language />} />
                        </BottomNavigation>
                    </LoadingDashboardWrapper>
                </Card>
            </Grid>
        </Grid>
    );
};

export default OverviewAdmin;
